const ExerciseInstruction = ({ instruction }) => (
  <div className="bg-yellow-100 border border-yellow-400 sm:border-2 rounded-lg sm:rounded-xl p-2 sm:p-4 mb-3 sm:mb-4 text-yellow-800 text-xs sm:text-base font-bold text-right">
    {instruction}
  </div>
);

export default ExerciseInstruction